import React, { FC, useEffect, useState } from "react";
import { Row, Col, Input, Button } from "antd";
import { ReactSVG } from "react-svg";
import { SearchOutlined } from "@ant-design/icons";
import {
  SearchPanel,
  MessagePanel,
  MapPanel,
  HeaderPanel,
  RideDispatchPanel,
  RxPanel,
  Nine11Panel,
  StorePanel,
  LogisticsPanel,
  ContactTracePanel,
} from "../../components/Dashboard";
import "../Dashboard/Dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "react-google-autocomplete";
import RidePanel from "components/Dashboard/RidePanel";
import { useHistory, useParams } from "react-router-dom";
import {
  getPagesRequestPublishTopic,
  getPagesSubscriptionTopic,
  getCLBSLocations,
} from "hooks/MQTTConstants";
import { GET_USERS_LIST } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {MapTopics, SocketTopics} from '../../constants/enums'
import {getItemListRequestPayload} from '../../helpers/request/RequestPayload'
import {getMembersPageListPath} from "../../helpers/request/RequestPath"

import {RID, TOKEN} from "../../constants/localStoreKeys"
import useLocalStorageService from "../../services/localStorage"

const MapContainer: FC<{  socket: ISocket }> = ({  socket }) => {
  const { searchResult, selectedItem } = useSelector(
    (state: RootState) => state.search
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const { pageId } = useParams<{ pageId?: string }>();
  const [screens, setScreens] = useState<ScreenStateObj>({
    list: false,
    message: false,
    map: true,
    active: "map",
    ridePanel: false,
    cadType: "",
  });

  const {getLocalStorageItem} = useLocalStorageService();

  const params = {
    screens,
    setScreens,
  };

  useEffect(() => {
    dispatch(GET_USERS_LIST());
    if (!localStorage.getItem(TOKEN)) {
      history.push("/auth/login");
    }
  }, []);

  const setSelectedPage = (item: SelectedSearchItem | undefined) => {
    setScreens({
      ...screens,
      map: true,
      message: true,
      rxPanel: false,
      ridePanel: false,
      active: "",
    });
    dispatch({ type: "SET_SELECTED_ITEM", payload: item });
  };

  useEffect(() => {
    if (pageId && searchResult && searchResult.length > 0) {

      socket.subscribeToEvent(SocketTopics.SubscribePageTopics, `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem('CID')}/connection/${localStorage.getItem('CID')}/focusMap`)
      if (pageId === "home") {
        dispatch({ type: "SET_MAP_TYPE", payload: "HOME" });
      } else {
        const page = searchResult.find((item) => item.pageId === +pageId);
        console.log(searchResult);
        setSelectedPage(page);
      }
    }
  }, [pageId, searchResult]);

  useEffect(() => {
    console.log("selectedItem");
    console.log(selectedItem);
    if (selectedItem?.pageId) {
      setScreens({
        ...screens,
        map: true,
        message: true,
        ridePanel: false,
        active: "",
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (socket.client) {

      socket.subscribeToEvent(SocketTopics.SubscribePageTopics, getPagesSubscriptionTopic());

      socket.publishToEvent(SocketTopics.PublishPageTopics,  getPagesRequestPublishTopic(), getItemListRequestPayload([getMembersPageListPath(getLocalStorageItem(RID))]) )

    }
  }, [socket.client]);

  useEffect(() => {}, [socket.client]);

  const fixedColSize = pageId ? 12 : 8;

  return (
    <Row className="main-layout">
      <Col md={24} xs={24} className={"active-screen"}>
        <MapPanel socket={socket} params={params} />
      </Col>
      <Autocomplete
        apiKey="AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
        style={{ display: "none" }}
        options={{
          types: ["(regions)"],
          componentRestrictions: { country: ["us", "ca", "uk"] },
        }}
      />
    </Row>
  );
};

export default MapContainer;
